import { useEffect } from "react";
import { useRouter } from "next/router";
import { useAuth } from "stores/auth/auth-context";
import { isObjectEmpty } from "utils/utils";

import { LoadingSpinner } from "components/icons/loading-spinner";
import { PageLoader } from "styles/common/pageLoader";
import { UserType } from "types/common/common.types";
import { useRedirectAfterLogin } from "hooks/use-redirect-after-login/use-redirect-after-login";

const AuthRedirect = (): JSX.Element => {
  const router = useRouter();
  const {
    user,
    signOutUser,
    user: { setUserData }
  } = useAuth();
  const { redirectAfterLogin } = useRedirectAfterLogin();

  useEffect(() => {
    const { primary_user, parent_user, register_token, student_users } =
      user.userData;

    //Conditions for paket login flow
    if (!isObjectEmpty(router.query) && router.query.package) {
      if (register_token) {
        router.push({ pathname: "/user/select-role", query: router.query });
        return;
      } else {
        if (!isObjectEmpty(primary_user) && !isObjectEmpty(parent_user)) {
          router.push({ pathname: "/user/select-role", query: router.query });
          return;
        }

        if (student_users.length > 1) {
          setUserData({ ...user.userData, userType: UserType.STUDENT });
          router.push({
            pathname: "/paket/user/select-student",
            query: router.query
          });

          return;
        }

        if (!isObjectEmpty(parent_user)) {
          setUserData({ ...user.userData, userType: UserType.PARENT });
          if (parent_user && parent_user.students.length > 1) {
            router.push({
              pathname: "/paket/user/select-student",
              query: router.query
            });
            return;
          } else {
            router.push({
              pathname: "/paket/user/summary",
              query: { ...router.query, user_id: primary_user.id }
            });
            return;
          }
        }

        if (isObjectEmpty(primary_user) && !isObjectEmpty(parent_user)) {
          setUserData({ ...user.userData, userType: UserType.PARENT });
          router.push({
            pathname: "/paket/user/summary",
            query: { ...router.query, user_id: primary_user.id }
          });
          return;
        }

        // student without parent
        if (isObjectEmpty(parent_user) && register_token === null) {
          router.push({
            pathname: "/paket/user/add-parent",
            query: router.query
          });
          return;
        }
      }

      // Conditions for main login flow
    } else {
      if (register_token) {
        router.push({ pathname: "/user/select-role", query: router.query });
        return;
      } else {
        // if primary_user is there
        if (!isObjectEmpty(primary_user)) {
          if (primary_user.profile_state === "INCOMPLETE") {
            router.push({
              pathname: "/user/register/add-location",
              query: router.query
            });
            return;
          }
          if (student_users && student_users.length > 1) {
            router.push({
              pathname: "/user/select-student",
              query: router.query
            });
            return;
          } else {
            redirectAfterLogin();
            return;
          }
        } else {
          signOutUser();
        }
      }
    }
  }, []);
  return (
    <PageLoader>
      <LoadingSpinner />
    </PageLoader>
  );
};
AuthRedirect.requireAuth = true;
export default AuthRedirect;
